import React from 'react'
import ReactDOM from 'react-dom'
import { ConfigProvider } from 'antd'
import thTH from 'antd/lib/locale-provider/th_TH'
import { ThemeProvider } from 'styled-components'
import 'antd/dist/antd.less'
import 'react-table/react-table.css'
// import '@fortawesome/fontawesome-pro/css/all.css'
import './index.css'
import App from './App'
// eslint-disable-next-line
import './styles/_override.css?global'
import { theme } from './styles/_variables'
import 'moment/locale/th'

ReactDOM.render(
    <ConfigProvider locale={thTH}>
        <ThemeProvider theme={theme}>
            <App />
        </ThemeProvider>
    </ConfigProvider>, document.getElementById('root'),
)
